import { boot } from 'quasar/wrappers';

import { ALLOW_PICK_EXISTING_FILES_KEY } from 'SharedDir/constants/file-uploader';
import { provideCommonServices } from 'SharedDir/service/common';

export default boot(({ app }) => {
  provideCommonServices(app);
  app.provide(ALLOW_PICK_EXISTING_FILES_KEY, false);
});
